module.exports = __webpack_public_path__ + "img/SAFP_Logo.4acba310.jpg";